<template>
  <div class="types-wrapper">
    <div class="types-container">
      <div v-if="(!isAddingType && !isAddingSubType && !editingTypeEnabled && !editingSubTypeEnabled)">
        <div class="types-header-container">
          <h4>Type</h4>
        </div>
        <div class="types">
          <CustomerType v-for="(type, index) in types" :key="type.id" :data-id="type.id" :data-counter="index"
            :type="type"
            :added="addedTypeId === type.id"
            :added-sub-type-id="addedSubTypeId"
            :edited-sub-type-id="editedSubTypeId"
            :updated="editedTypeId === type.id && typeUpdated"
            @customerTypeDeleted="fetchCustomerTypes"
            @customerTypeEditingEnabled="renderTypeEdit"
            @customerSubTypeDeleted="fetchCustomerTypes"
            @customerSubTypeEditingEnabled="renderSubTypeEdit"
          />
        </div>
        <button type="submit" @click="addNewType" name="submit" class="btn btn--primary add-type-button">Add New Type</button>
        <button type="submit" @click="addNewSubType" name="submit" class="btn btn--primary add-type-button">Add New Sub-Type</button>
      </div>
      <div v-if="editingTypeEnabled">
        <EditCustomerType
          :type_id="editedTypeId"
          :type="editedType"
          @customerTypeUpdated="markAsUpdated"
          @customerTypeCancel="cancel"
        />
      </div>
      <div v-if="editingSubTypeEnabled">
        <EditCustomerSubType
          :type_id="editedSubTypeId"
          :subType="editedSubType"
          @customerSubTypeUpdated="markSubtypeAsUpdated"
          @customerTypeCancel="cancel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomerType from './CustomerType.vue';
import EditCustomerType from './EditCustomerType.vue';
import EditCustomerSubType from './EditCustomerSubType.vue';

export default {
  name: 'Types',
  components: { CustomerType, EditCustomerType, EditCustomerSubType },
  data() {
    return {
      types: [],
      subTypes: [],
      isAddingType: false,
      isAddingSubType: false,
      addedTypeId: null,
      addedSubTypeId: null,
      editedTypeId: null,
      editedType: null,
      editingTypeEnabled: false,
      editedSubTypeId: null,
      editedSubType: null,
      editingSubTypeEnabled: false,
      typeUpdated: false,
      subTypeUpdated: false,
    }
  },
  methods: {
    addNewType() {
      this.$router.push('/admin/add_new_type');
    },
    addNewSubType() {
      this.$router.push('/admin/add_new_sub_type');
    },
    cancel() {
      this.isAddingType = false;
      this.isAddingSubType = false;
      this.editingTypeEnabled = false;
      this.editingSubTypeEnabled = false;
    },
    markAsUpdated(updatedTypeId) {
      this.editedTypeId = updatedTypeId
      this.addedTypeId = null
      this.typeUpdated = true;
      this.fetchCustomerTypes()
      setTimeout(()=>{
        this.editedTypeId = null
      }, 3000);
    },
    markSubtypeAsUpdated(updatedSubTypeId) {
      this.editedSubTypeId = updatedSubTypeId
      this.addedSubTypeId = null
      this.subTypeUpdated = true;
      this.fetchCustomerTypes()
      setTimeout(()=>{
        this.editedSubTypeId = null
      }, 3000);
    },
    fetchCustomerTypes() {
      this.axios.get('/v1/types.json').then(response => {
        this.types = response.data.records;
      }).catch((error) => {
        console.log(error)
      });
      this.axios.get('/v1/sub_types.json').then(response => {
        this.subTypes = response.data.records;
      }).catch((error) => {
        console.log(error)
      });
      this.isAddingType = false;
      this.isAddingSubType = false;
      this.editingTypeEnabled = false;
      this.editingSubTypeEnabled = false;
    },
    renderTypeEdit(type) {
      this.editedTypeId = type.id;
      this.editedType = type;
      this.editingTypeEnabled = true;
      event.preventDefault();
      this.typeUpdated = false;
    },
    renderSubTypeEdit(subType) {
      this.editedSubTypeId = subType.id;
      this.editedSubType = subType;
      this.editingSubTypeEnabled = true;
      event.preventDefault();
      this.typeUpdated = false;
    },
    handleBackButton(){
      this.editingTypeEnabled = false;
    }
  },
  mounted() {
    window.addEventListener("popstate", this.handleBackButton, false);

    this.fetchCustomerTypes()
    this.addedSubTypeId = parseInt(this.$route.query.added_sub_type_id)
    setTimeout(() => {
      this.addedSubTypeId = null
    }, 3000);
    this.addedTypeId = parseInt(this.$route.query.added_type_id)
    setTimeout(()=>{
      this.addedTypeId = null
    }, 3000);
  },
  onUnmounted() {
    window.removeEventListener("popstate", this.handleBackButton);
  }
}
</script>
<style scoped>
.types-wrapper {
  width: 100%;
}

.types-header-container {
  width: 50vw;
  display: flex;
  justify-content: flex-start;
}
.types-container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  grid-auto-flow: column;
}
.add-type-button {
  margin-top: 25px;
}
@media screen and (max-width: 992px) {
  .types-wrapper {
    width: 100%;
  }
}

</style>
